import React from "react";

const Bye = ({bye}) => (
	<div className="tie">
		<p className="bye-label">Bye</p> 
		<p>{bye}</p>
	</div>
);

export default Bye;